import { FC } from 'react';
import { SummaryStatCard } from 'components/summary-stat-card/summary-stat-card';
import { formatNumber } from 'utils/number';
import type { ProvisioningBatch } from '../types';
import styles from '../page.module.scss';

interface BatchSummaryCardsProps {
  batch: ProvisioningBatch;
}

export const BatchSummaryCards: FC<BatchSummaryCardsProps> = ({ batch }) => {
  const breakdown = batch.pipelineBreakdown;

  return (
    <div className={styles.cardsContainer}>
      <div className={styles.cardCell}>
        <SummaryStatCard
          title="Total"
          value={formatNumber(batch.totalCount, 0, 0, 'decimal', true, '--')}
          subtitle={
            breakdown
              ? `${formatNumber(
                  breakdown.direct,
                  0,
                  0,
                  'decimal',
                  true,
                  '0'
                )} direct · ${formatNumber(
                  breakdown.submission,
                  0,
                  0,
                  'decimal',
                  true,
                  '0'
                )} via pipeline`
              : undefined
          }
        />
      </div>

      <div className={styles.cardCell}>
        <SummaryStatCard
          title="Completed"
          value={formatNumber(
            batch.completedCount,
            0,
            0,
            'decimal',
            true,
            '--'
          )}
          valueColor="green"
        />
      </div>

      <div className={styles.cardCell}>
        <SummaryStatCard
          title="Failed"
          value={formatNumber(batch.failedCount, 0, 0, 'decimal', true, '--')}
        />
      </div>

      <div className={styles.cardCell}>
        <SummaryStatCard
          title="Entities"
          value={formatNumber(
            batch.entitiesCreatedCount,
            0,
            0,
            'decimal',
            true,
            '--'
          )}
        />
      </div>

      <div className={styles.cardCell}>
        <SummaryStatCard
          title="Locations"
          value={formatNumber(
            batch.locationsCreatedCount,
            0,
            0,
            'decimal',
            true,
            '--'
          )}
        />
      </div>

      <div className={styles.cardCell}>
        <SummaryStatCard
          title="Addresses"
          value={formatNumber(
            batch.addressesCreatedCount,
            0,
            0,
            'decimal',
            true,
            '--'
          )}
        />
      </div>

      <div className={styles.cardCell}>
        <SummaryStatCard
          title="Capacities"
          value={formatNumber(
            batch.capacitiesCreatedCount,
            0,
            0,
            'decimal',
            true,
            '--'
          )}
        />
      </div>

      <div className={styles.cardCell}>
        <SummaryStatCard
          title="Citations"
          value={formatNumber(
            batch.citationsCreatedCount,
            0,
            0,
            'decimal',
            true,
            '--'
          )}
        />
      </div>
    </div>
  );
};
